'use strict'

import React from 'react';
import Translations from '../../app/utils/translations.js';

import sendCommand from '../../app/utils/sendCommand.js';
/*
let translations=new Translations([
    require('./labels/english.js'),
    require('./labels/norwegian.js')
  ]);
*/

export default class ReleaseFlow extends React.Component {

  completeRelease(event) {
    if (this.props.onComplete) {
      this.props.onComplete();
    }
  }

  render() {
    return this.props.release.historic===true ? (
      <div>
        {this.props.release.method==="product" ? (
          <a href={"/releases/"+this.props.release.id}>Go to release</a>
        ) : null}
        {this.props.release.method==="project" ? (
          <a href={"/projects/"+this.props.release.implementationProject.id}>Go to project</a>
        ) : null}
      </div>
    ) : this.props.release.active!==true ? (
      <div>
        <a href="#" onClick={this.props.activate}>Make Release active</a>
      </div>
    ) : (
      <div>
        {this.props.disableEdit!==true ? (
          <div>
            <a href="#" onClick={this.completeRelease.bind(this)}>Set Completed</a>
          </div>
        ) : null}
        {this.props.release.method==="product" ? (
          <a href={"/releases/"+this.props.release.id}>Go to release</a>
        ) : null}
        {this.props.release.method==="project" ? (
          <a href={"/projects/"+this.props.release.implementationProject.id}>Go to project</a>
        ) : null}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./views/product/ReleaseFlow.jsx